import type { RxJsonSchema } from 'rxdb';
import type { InspectionFiles } from './inspectionFiles.types';

export const inspectionFilesSchema: RxJsonSchema<InspectionFiles> = {
  type: 'object',
  version: 0,
  description: 'describes inspection files',
  primaryKey: 'fileUUID',
  properties: {
    fileUUID: { type: 'string', maxLength: 36 },
    fileId: { type: ['string', 'null'] },
    name: { type: ['string', 'null'] },
    originalFileName: { type: ['string', 'null'] },
    originalPath: { type: ['string', 'null'] },
    legacyId: { type: ['number', 'null'] },
    isImageFile: { type: ['boolean', 'null'] },
    inspectionId: { type: ['string', 'null'] },
    showOnReport: { type: ['boolean', 'null'] },
    fileDescription: { type: ['string', 'null'] },
    drawingType: { type: ['number', 'null'] },
    fileCategory: { type: ['number', 'null'] },
    pcsId: { type: ['string', 'null'] },
    fkAimsfileTblSp: { type: ['string', 'null'] },
    sizeMb: { type: ['number', 'null'] },
    allowSpaccess: { type: ['boolean', 'null'] },
    siteId: { type: ['number', 'null'] },
    disciplineId: { type: ['number', 'null'] },
    userCreated: { type: ['string', 'null'] },
    userModified: { type: ['string', 'null'] },
    extension: { type: ['string', 'null'] },
    dateCreated: { type: ['string', 'null'] },
    dateModified: { type: ['string', 'null'] },
    isDelete: { type: ['string', 'null'] },
    fkAssetInspectionTask: { type: ['number', 'null'] },
    fkInspectorField: { type: ['number', 'null'] },
    fkInspectorLead: { type: ['number', 'null'] },
    fileSortOrder: { type: ['number', 'null'] },
  },
};
